module.exports = __webpack_public_path__ + "static/media/modal-close.86f00500.svg";